import { defineMessages } from 'react-intl';

export default defineMessages({
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    error: {
        id: 'portal.index.Error',
        defaultMessage: 'Error'
    },
    gpaTitle: {
        id: 'portal.index.GPA Title',
        defaultMessage: 'BluePass'
    },
    errorMessage: {
        id: 'portal.index.Sorry, an error occurred. You can try again later or contact us.',
        defaultMessage: 'Sorry, an error occurred. You can try again later or contact us.'
    },
    errorMetadataMessage: {
        id: 'portal.index.No product metadata please refer to README for building metadata.',
        defaultMessage: 'No product metadata please refer to README for building metadata.'
    },
    searchPlaceHolder: {
        id: 'gateway.views.search-quote.Search by account or policy number.',
        defaultMessage: 'Search by account or policy number...',
    },
    login: {
        id: 'auth.components.AuthStatus.Login',
        defaultMessage: 'Login',
    },
    account: {
        id: 'auth.components.AuthStatus.Account',
        defaultMessage: 'Account',
    },
    preferences: {
        id: 'auth.components.AuthStatus.Preferences',
        defaultMessage: 'Preferences',
    },
    logOut: {
        id: 'auth.components.AuthStatus.Log out',
        defaultMessage: 'Log out',
    },
    quoteAnyAccount: {
        id: 'gateway.views.new-quote.Quote for Any Account',
        defaultMessage: 'Quote for Any Account'
    },
    quoteThisAccount: {
        id: 'gateway.views.new-quote.Quote for This Account',
        defaultMessage: 'Quote for This Account'
    },
    viewAll: {
        id: 'gateway.views.new-quote.View all',
        defaultMessage: 'View all matches of number: {Number}',
    },
    accountsTab: {
        id: 'app.html.index.AccountsTab',
        defaultMessage: 'Accounts',
    },
    policiesTab: {
        id: 'app.html.index.PoliciesTab',
        defaultMessage: 'Policies',
    },
    claimsTab: {
        id: 'app.html.index.ClaimsTab',
        defaultMessage: 'Claims',
    },
    activitiesTab: {
        id: 'app.html.index.ActivitiesTab',
        defaultMessage: 'Activities',
    },
    commissionTab: {
        id: 'app.html.index.CommissionTab',
        defaultMessage: 'Commission',
    },
    errorModalHeader: {
        id: 'agent.views.modal.Error',
        defaultMessage: 'Error'
    },
    account: {
        id: 'gateway.views.search.Account',
        defaultMessage: 'Account',
    },
    policy:{
        id:'gateway.views.search.Policy',
        defaultMessage: 'Policy',
    },

});
